import VueI18n from '../i18n/i18n'
let $I18n = VueI18n

const fun = {
	formatTime2(date) {
		console.log(date)
		if(!date){ return "" }
	   const now = new Date();
	   const oneHour = 60 * 60 * 1000; // 1小时对应的毫秒数
	   const oneDay = 24 * 60 * 60 * 1000; // 1天对应的毫秒数
	
	   const diff = now - date;
	   if (diff < oneHour) {
	     const minutes = Math.floor(diff / (60 * 1000));
		  if(minutes < 1){
			  return `Just now`;
		  }else{
			  return `${minutes} minute ago`;
		  }
	   } else if (diff < oneDay) {
	     const hours = Math.floor(diff / oneHour);
	     return `${hours} hour ago`;
	   } else if (diff < 2 * oneDay) {
	     return "Yesterday";
	   } else {
	     const days = Math.floor(diff / oneDay);
	     return `${days} days ago`;
	   }
	},
	
	// 转化时间
	formatDate(time) {
		if (time) {
			time     = time * 1000 //十位时间戳要*1000等于13位转化
			let date = new Date(time)
			let YY   = date.getFullYear() // 年
			let MM   = date.getMonth() + 1 // 月
			MM       = MM < 10 ? ("0" + MM) : MM
			let DD   = date.getDate() // 日
			DD       = DD < 10 ? ("0" + DD) : DD
			let hh   = date.getHours() // 时
			hh       = hh < 10 ? ("0" + hh) : hh
			let mm   = date.getMinutes() // 分
			mm       = mm < 10 ? ("0" + mm) : mm
			let ss   = date.getSeconds() // 秒
			ss       = ss < 10 ? ("0" + ss) : ss
			return YY + "-" + MM + "-" + DD + " " + hh + ":" + mm + ":" + ss
		} else {
			return ""
		}
	},
	
	formatTime(timestamp) {
		if(!timestamp){ return }
		const now = new Date();
	   const targetTime = new Date(timestamp * 1000);  // 10位时间戳单位是秒，需转换为毫秒
	   const timeDiff = now - targetTime;
	   const secondsDiff = Math.floor(timeDiff / 1000);  // 时间差换算为秒
	   if (secondsDiff < 60) {
	      return `${$I18n.t('timeArr.Just_now')}`;
	   } else if (secondsDiff >= 60 && secondsDiff < 3600) {
	      const minutes = Math.floor(secondsDiff / 60);
	      return `${minutes} ${$I18n.t('timeArr.minute_ago')}`;
	   } else if (secondsDiff >= 3600 && secondsDiff < 86400) {
	      const hours = Math.floor(secondsDiff / 3600);
	      return `${hours} ${$I18n.t('timeArr.hour_ago')}`;
	   } else if (secondsDiff >= 86400 && secondsDiff < 2 * 86400) {
	      return `${$I18n.t('timeArr.Yesterday')}`;
	   } else if (secondsDiff >= 2 * 86400 && secondsDiff <= 7 * 86400) {
	      const days = Math.floor(secondsDiff / 86400);
	      return `${days} ${$I18n.t('timeArr.days_ago')}`;
	   } else {
	      const year = targetTime.getFullYear();
	      const month = String(targetTime.getMonth() + 1).padStart(2, '0');
	      const day = String(targetTime.getDate()).padStart(2, '0');
	      const hour = String(targetTime.getHours()).padStart(2, '0');
	      const minute = String(targetTime.getMinutes()).padStart(2, '0');
	      const second = String(targetTime.getSeconds()).padStart(2, '0');
	      return `${year}-${month}-${day}  ${hour} : ${minute} : ${second}`;
	   }
	},
	
	// formatTime(timestamp) {
	// 	if(!timestamp){ return }
	// 	const now = new Date();
 //      const targetTime = new Date(timestamp * 1000);  // 10位时间戳单位是秒，需转换为毫秒
 //      const timeDiff = now - targetTime;
 //      const secondsDiff = Math.floor(timeDiff / 1000);  // 时间差换算为秒
 //      if (secondsDiff < 60) {
 //         return "Just now";
 //      } else if (secondsDiff >= 60 && secondsDiff < 3600) {
 //         const minutes = Math.floor(secondsDiff / 60);
 //         return `${minutes} minute ago`;
 //      } else if (secondsDiff >= 3600 && secondsDiff < 86400) {
 //         const hours = Math.floor(secondsDiff / 3600);
 //         return `${hours} hour ago`;
 //      } else if (secondsDiff >= 86400 && secondsDiff < 2 * 86400) {
 //         return "Yesterday";
 //      } else if (secondsDiff >= 2 * 86400 && secondsDiff <= 7 * 86400) {
 //         const days = Math.floor(secondsDiff / 86400);
 //         return `${days} days ago`;
 //      } else {
 //         const year = targetTime.getFullYear();
 //         const month = String(targetTime.getMonth() + 1).padStart(2, '0');
 //         const day = String(targetTime.getDate()).padStart(2, '0');
 //         const hour = String(targetTime.getHours()).padStart(2, '0');
 //         const minute = String(targetTime.getMinutes()).padStart(2, '0');
 //         const second = String(targetTime.getSeconds()).padStart(2, '0');
 //         return `${year}-${month}-${day} ${hour} : ${minute} : ${second}`;
 //      }
	// },

  // 转化时间
  specific_date(time) {
  	if (time) {
  		time     = time * 1000 //十位时间戳要*1000等于13位转化
  		let date = new Date(time)
  		let YY   = date.getFullYear() // 年
  		let MM   = date.getMonth() + 1 // 月
  		MM       = MM < 10 ? ("0" + MM) : MM
  		let DD   = date.getDate() // 日
  		DD       = DD < 10 ? ("0" + DD) : DD
  		return YY + "-" + MM + "-" + DD
  	} else {
  		return ""
  	}
  },

	formatDateV2(timestamp) {
		let dateStr = ""
		if (timestamp) {
			let date = new Date(timestamp * 1000)
			let YY   = date.getFullYear()
			let MM   = String(date.getMonth() + 1).padStart(2, "0")
			let dd   = String(date.getDate()).padStart(2, "0")
			let hh   = String(date.getHours()).padStart(2, "0")
			let mm   = String(date.getMinutes()).padStart(2, "0")
			let ss   = String(date.getSeconds()).padStart(2, "0")
			dateStr  = YY + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss
		}
		return dateStr
	},

	// 转化毫秒数对应的时分秒
	get_play_time(time) {
		// 转换为式分秒
		let h = parseInt(time / 60 / 60 % 24)
		h     = h < 10 ? "0" + h : h
		let m = parseInt(time / 60 % 60)
		m     = m < 10 ? "0" + m : m
		let s = parseInt(time % 60)
		s     = s < 10 ? "0" + s : s
		return h + ":" + m + ":" + s
	},

	// 转化文件大小
	get_size(size) {
		if (!size) return ""
		var num = 1024.00 //byte
		if (size < num)
			return size + "B"
		if (size < Math.pow(num, 2))
			return (size / num).toFixed(2) + "KB" //kb
		if (size < Math.pow(num, 3))
			return (size / Math.pow(num, 2)).toFixed(2) + "MB" //M
		if (size < Math.pow(num, 4))
			return (size / Math.pow(num, 3)).toFixed(2) + "G" //G
		return (size / Math.pow(num, 4)).toFixed(2) + "T" //T
	},

	//转化处理人
	get_peopleName(name) {
		if (name) {
			return name
		} else {
			return ""
		}
	},

	//审核状态 活动列表
	get_Audit_status(num) {
		if (num == 1) {
			return "已审核"
		} else if (num == 2) {
			return "已关闭"
		} else if (num == 3) {
			return "待审核"
		} else {
			return "草稿"
		}
	},

	//申请状态 活动申请
	get_apply_status(num) {
		if (num == 1) {
			return "待审核"
		} else if (num == 2) {
			return "参与成功"
		} else if (num == 3) {
			return "参与失败"
		} else {
			return "已取消"
		}
	},

	//活动状态
	get_activity_status(num) {
		if (num == 1) {
			return "未开始"
		} else if (num == 2) {
			return "进行中"
		} else if (num == 3) {
			return "已结束"
		} else {
			return ""
		}
	},

  //帖子、评论显示状态
  get_Posts_Comments_status(num) {
  	if (Number(num) === 1) {
  		return "可见"
  	} else if (Number(num) === 2) {
  		return "不可见"
  	} else {
  		return "未知"
  	}
  },

  //帖子类型
  get_Posts_type(num) {
  	if (Number(num) === 1) {
  		return "图文"
  	} else if (Number(num) === 2) {
  		return "视频"
  	} else {
  		return "未知"
  	}
  },

  // 处理文件名过长省略
  getFileName(nameString, Reserved, Intercept) {
    if (nameString && nameString.length > 0) {
      var name = nameString.substring(nameString.lastIndexOf("/") + 1)
      let ReservedNum = Reserved ? Reserved : 30
      let InterceptNum = Intercept ? Intercept : 20
    	if(name.length > ReservedNum){
    	  var text = name
    	  var maxLength = InterceptNum; // 设置前后显示的字符数
    	  var truncatedText = text.substring(0, maxLength) + " ... " + text.substring(text.length - maxLength);
    	  return truncatedText
    	}else{
    	  return name
    	}
    }else{
      return ''
    }
  },

  // 处理url的文件名
  getUrlFileName(nameString) {
    if (nameString && nameString.length > 0) {
      var name = nameString.substring(nameString.lastIndexOf("/") + 1)
      return name ? name : nameString
    }else{
      return ''
    }
  },

  // 处理url转为obj兼容
  getUrlFileList(arr) {
    let list = []
    if(arr && arr.length > 0){
      arr.forEach((item, index) =>{
        let obj;
        if(item.url){
          obj = item
        }else{
          obj = {
            name:  fun.getUrlFileName(item),
            url: item
          }
        }
        list.push(obj)
      })
    }
    return list
  },

  // 清空对象的值
  clear_Data(obj) {
  	Object.keys(obj).forEach((key) => {
      if(obj[key] instanceof Array){
        obj[key] = []
      }else if(obj[key] instanceof Object){
        obj[key] = {}
      }else{
        obj[key] = ""
      }
      return obj
    })
    return obj
  },

  // 获取路由参数
  get_route_name(str, num) {
    const parts = str.split("_");
    if (num >= 1 && num <= parts.length) {
      return parts[num - 1];
    } else {
      return str;
    }
  },

  // 获取产品名称
  get_product_name(name) {
    console.log(name)
    if (name && name.length > 0) {
      if(Array.isArray(name)){
        return name[1]
      }else{
        return name
      }
    } else {
      return '';
    }
  },
  
  
  	textWithLineBreaks(text){
		if(!text){ return }
		return text.replace(/\n/g, '<br>');
	}

  // const str = "第一个-第二个-第三个-第四个";
  // console.log(get_route_name(str, 2)); // 输出：第二个
  // console.log(get_route_name(str, 4)); // 输出：第四个
  // console.log(get_route_name(str, 5)); // 输出：无效的位置

  // get_route_name(str, num){
  //   const firstPart = str.substring(0, str.indexOf("-")); // 第一个-前的字符
  //   const secondPart = str.substring(str.indexOf("-") + 1, str.indexOf("-", str.indexOf("-") + 1)); // 第一个-到第二个-的字符
  //   const thirdPart = str.substring(str.indexOf("-") + 2, str.indexOf("-", str.indexOf("-") + 2)); // 第二个-到第三个-的字符
  //   const fourPart = str.substring(str.indexOf("-", str.indexOf("-") + 2) + 2); // 第三个-之后的字符

  //   if(num == 1){
  //     return firstPart
  //   }else if(num == 2){
  //     return secondPart
  //   }else if(num == 3){
  //     return thirdPart
  //   }else if(num == 4){
  //     return fourPart
  //   }else{
  //     return str
  //   }
  //   // console.log(firstPart); // 输出：第一个
  //   // console.log(secondPart); // 输出：第二个
  //   // console.log(thirdPart); // 输出：第三个
  // },


}
export default fun
